import React from 'react';

import {DevicesView} from './devicesView'

const { formatText } = require('core/i18n').i18n;

class DevicesStandardView extends React.PureComponent {
    render() {
        const gridTitle = formatText("manageDevices-explanationTextTitle")
        const gridDescription = formatText("manageDevices-explanationTextDesc")
        const mappingBreadcrumb = [
            ...(!__CONTACT_CENTER__ ?
                {
                    text: formatText("profileKeysLanding-title"),
                    url: "/myprofile/keys"
                } : []),
        {
            text: formatText("breadcrumb-recentActivity")
        }
        ]

        return (
            <DevicesView
                forgotten={false}
                breadcrumb={mappingBreadcrumb}
                headerKey={'landingHeader-manageDevices'}
                firstTableTitle={gridTitle}
                firstTableDescription={gridDescription}
            />
        );
    }
}

export default { DevicesStandardView }
